// @ts-nocheck
import React, { useEffect } from 'react';
import ButtonComponents from '../commonComponents/ButtonComponents';

export const AuctionStatus = ({ isLive, NextAuction, RemoveAuctionfromList }) => {
  const descriptionMessages = isLive?.descriptionMessage?.split('\n') || [];
 
  return (
    <div className="flex items-center justify-center min-h-[75vh]">
      <div className={isLive?.auctionStatus == 'Closed' ? "flex flex-col items-center justify-center gap-y-4 px-6 py-4 rounded-lg" : "flex flex-col items-center justify-center px-6 py-4 rounded-lg gap-y-4"} >
        <div className="text-[24px] font-[600] text-[#3B3B3B]">{isLive?.titleMessage}</div>
        <div className={(isLive?.subTitleMessage && !isLive?.auctionStatus == 'Closed') || isLive?.subTitleMessage === 'You Won!' ? "text-[30px] font-[600] text-[#37AE37]" : "text-[30px] font-[600] text-[#3B3B3B]"} >{isLive?.subTitleMessage}</div>

        {/* Render each message line separately */}

        {
          isLive?.auctionStatus == 'Closed' ?
            <>
              {descriptionMessages.map((message, index) => (
                <p key={index} className="text-[14px] font-[500] text-[#3B3B3B] ">
                  {message}
                </p>
              ))}
            </>
            :
            <div>
              {descriptionMessages.map((message, index) => (
                <p key={index} className={isLive?.subTitleMessage === 'You Won!' ? "text-[14px] font-[500] text-[#3B3B3B] py-0.8 text-center mt-[-12px] " : "text-[14px] font-[500] text-[#3B3B3B] py-0.8 text-center "}>
                  {message}
                </p>
              ))}
            </div>
        }

        {/* Optional additional message */}
        {/* <div className="text-[16px] font-[500] text-[#3B3B3B]">
          Explore other properties from our inventory &amp; place your next bid.
        </div> */}

        <button
          className="bg-[#FF5C39] pr-3 pl-3 py-2 mt-2 text-white text-[18px] font-[500] rounded-md"
          tabIndex="0"
          type="button"
          aria-label="button close"
          onClick={() => RemoveAuctionfromList(isLive?.auctionId)}
        >
          Close
        </button>
      </div>
    </div>
  );
};
